import { parseEnv } from '@/helpers/route-utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import * as z from 'zod/v4';

export const Route = createFileRoute('/_auth/$env/collections')({
  validateSearch: zodValidator(
    z.object({
      search: z.string().optional().default(''),
      id: z.string().optional(),
      mode: z.enum(['new', 'edit']).optional(),
      page: z.number().optional().default(1),
      pageSize: z.number().optional().default(10),
      translationSidebarOpen: z.boolean().optional(),
    }),
  ),
  params: parseEnv(),
});
